<template lang="pug">
div
  v-card.border.rounded-lg.pa-6(outlined min-height="100vh")
    v-row(dense align="center")
      v-col(cols="5")
        div.text-sm.font-semibold.neutral700--text Activities
      v-col(cols="7")
        y-select(v-model="type" small placeholder="Select campaign" attach :items="types" item-text="text" item-value="value" @change="fetchActivities")
    div.mt-3
      div.d-flex.justify-center.mt-16(v-if="isFetching")
        v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        div.py-3(v-for="activity in activities")
          div.text-xs.neutral700--text
            span.font-medium.mr-1 {{ activity.name }}
            | left a {{ activity.type }}
          div.d-flex.align-center.mt-2
            template(v-for="n in activity.star")
              v-icon.mr-1(color="warning500" size="15") $yzi-star-01-fill
            template(v-for="n in (5 - activity.star)")
              v-icon.mr-1(color="neutral500" size="15") $yzi-star-01
          div.d-flex.align-center.mt-2
            v-avatar.mr-2(size="3" color="blue500")
            div.text-xs.neutral500--text {{ activity.created | convertToHumanizeTime }}

        div.py-3(v-if="!activities.length")
          div.text-xs.neutral500--text.font-medium.text-center.mt-6 No data

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      isFetching: false,
      type: 'review,feedback',
      activities: [],
      types: [
        { text: 'Feedback only', value: 'feedback' },
        { text: 'Reviews only', value: 'review' },
        { text: 'Feedback & Reviews', value: 'review,feedback' },
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      setting: 'marketing/getMarketingSettings'
    }),
  },
  mounted () {
    this.fetchActivities()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchActivities () {
      this.isFetching = true
      let params = {
        types: this.type,
      }
      this.$axios.get(`/reviews/${this.company.slug}/activities`, { params })
        .then(resp => {
          this.activities = resp.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>